import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET_LINE_ITEMS } from "./apiRoutes";

const mutateDeleteLineItem = async ({
  id,
  budgetId,
}: {
  id: string;
  budgetId: string;
}) => {
  return await axiosAuth.delete(`${BUDGET_LINE_ITEMS(budgetId)}/${id}`);
};

const useDeleteLineItemMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      budgetId: string;
      id: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteLineItem,
    ...queryParams,
  });

export default useDeleteLineItemMutation;
